module.exports = __webpack_public_path__ + "img/vip.d25f27dd.png";